import { useNavigate } from "react-router-dom";
import { FaUserAlt, FaUserMd } from "react-icons/fa"; // Import icons from react-icons

const UserTypeSelection = () => {
  const navigate = useNavigate();

  const handleUserTypeSelection = (type) => {
    if (type === "buyer") {
      navigate("/auth/login/buyer");
    } else {
      navigate("/auth/login/pharm");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      <h1 className="text-2xl font-bold text-green-600 mb-4 animate-bounce">
        Welcome!
      </h1>
      <h2 className="text-lg mb-12 font-semibold">Select your user type</h2>
      <div className="flex flex-col items-center lg:flex-row space-x-4">
        {/* Buyer Card */}
        <div
          onClick={() => handleUserTypeSelection("buyer")}
          className="flex flex-col items-center border border-green-500 rounded-lg p-6 cursor-pointer transition-transform transform hover:scale-105 w-[200px] h-[250px] relative mb-10"
        >
          <FaUserAlt
            className=" absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 mb-2 border border-green-500 rounded-full p-2 text-white bg-green-500"
            size={60}
          />
          <h3 className="text-xl font-semibold text-green-600 mt-10">Buyer</h3>
          <p className="text-md text-black mt-10 text-center ">
            Shop for medications and health products with ease.
          </p>
        </div>

        {/* Pharmacist Card */}
        <div
          onClick={() => handleUserTypeSelection("pharmacist")}
          className="flex flex-col items-center border border-green-500 rounded-lg p-6 cursor-pointer transition-transform transform hover:scale-105 w-[200px] h-[250px] relative"
        >
          <FaUserMd
            className=" absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 mb-2 border border-green-500 rounded-full p-2 text-white bg-green-500"
            size={60}
          />
          <h3 className="text-xl font-semibold text-green-600 mt-10">
            Pharmacist
          </h3>
          <p className="text-md text-black mt-10 text-center">
            Manage prescriptions and provide expert health advice.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserTypeSelection;
